export default __webpack_public_path__ + "static/media/email.ca6dbb21.svg";